<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on, attrs }">
      <p
        id="similarityDialog"
        v-bind="attrs"
        v-on="on"
        @click="openDialog"
      ></p>
    </template>

    <v-card>
      <v-card-title class="text-h5 grey lighten-3">
        Similarity Check
      </v-card-title>

      <v-card-text
        class="text-center mt-10"
        v-if="similarityList == null || similarityList.length == 0"
      >
        NO SIMILARITY FOUND
      </v-card-text>

      <v-card-text class="text-center mt-10" v-else>
        <v-data-table
          :headers="similarityHeaders"
          :items="similarityList"
          mobile-breakpoint="0"
          fixed-header
          height="50vh"
          dense
          hide-default-footer
        >
          <template v-slot:[`item.code`]="{ item }">
            <div style="width: 75px; font-size: 12px">
              {{ item.code }}
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <div style="min-width: 215px; font-size: 12px">
              {{ item.name }}
            </div>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          style="position: absolute; top: 10px; right: 10px;"
          color="grey darken-3"
          text
          @click="closeDialog"
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['similarityList'],
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    similarityHeaders() {
      const headers = [
        {
          text: 'Code',
          value: 'code',
          align: 'left',
          sortable: false
        },
        {
          text: 'Product Name',
          value: 'name',
          align: 'left',
          sortable: false
        }
      ]
      return headers
    }
  },
  methods: {
    openDialog() {
      setTimeout(() => {
        this.dialog = true
      }, 100)
    },
    closeDialog() {
      this.dialog = false
      setTimeout(() => {
        this.$emit('closeDialog')
      }, 100)
    }
  }
}
</script>
